import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MonthlyAttendanceReport.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProject, getStates, fetchMonths, getMonthlyAttendanceReport, getClients } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const MonthlyAttendanceReport = () => {
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    const [clientResponse, setClientResponse] = useState([]);
    const [clients, setClients] = useState(null);
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
        project: false,
        clients: false,
    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);
    const [designationData, setDesignationData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && district && month && year && project;
    // Function to calculate days in a month
    // const getDaysInMonth = (monthId, year) => {
    //     const monthIndex = monthId - 1; // Convert to 0-based for Date object
    //     if (!monthId || !year) return 0;

    //     const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
    //     const monthsWith30Days = [4, 6, 9, 11];

    //     if (monthsWith31Days.includes(monthId)) {
    //         return 31;
    //     } else if (monthsWith30Days.includes(monthId)) {
    //         return 30;
    //     } else if (monthId === 2) {
    //         const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    //         return isLeapYear ? 29 : 28;
    //     }
    //     return 0;
    // };

    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);

    // Fetch months
    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             setMonthOptions(
    //                 response.data
    //                     .map(item => ({
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                     }))
    //                     .sort((a, b) => a.value - b.value)
    //             );
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, []);
    // Fetch months
    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             const now = new Date();
    //             const currentYear = now.getFullYear();
    //             const currentMonth = now.getMonth() + 1; // Jan=1
    //             const currentDate = now.getDate();
    //             const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate(); // ✅ last day of current month

    //             const months = response.data
    //                 .map(item => {
    //                     let daysInMonth;

    //                     // If it's the current month of the current year
    //                     if (year === currentYear && item.monthId === currentMonth) {
    //                         daysInMonth = currentDate;
    //                     } else {
    //                         daysInMonth = new Date(year, item.monthId, 0).getDate();
    //                     }

    //                     return {
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                         days: daysInMonth,
    //                     };
    //                 })
    //                 .sort((a, b) => a.value - b.value);

    //             let filteredMonths = months;
    //             if (year) {
    //                 if (year === currentYear) {
    //                     filteredMonths = months.filter(m => {
    //                         if (m.value < currentMonth) return true; // past months always visible
    //                         if (m.value === currentMonth) {
    //                             // ✅ Show current month only if today is the last day
    //                             return currentDate === lastDayOfCurrentMonth;
    //                         }
    //                         return false;
    //                     });
    //                 } else if (year > currentYear) {
    //                     filteredMonths = []; // future year → no months
    //                 } else {
    //                     filteredMonths = months; // past year → all months
    //                 }
    //             }
    //             setMonthOptions(filteredMonths);
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, [year]);


    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            // if (!effectRan.current) {
            fetchDistricts();
            // }
            // return () => {
            //     effectRan.current = true;
            // }

        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    const data = await getClients(state);
                    setClientResponse(
                        data.map(client => ({
                            value: client.id,
                            label: client.clientName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching clients:', error);
                    setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
                }
            };
            fetchClients();
        } else {
            setClientResponse([]);
            setClients(null);



        }
    }, [state]);
    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProject(clients);
                    setProjectResponse(data.map(pro => ({
                        value: pro.id,
                        label: pro.projectCode,
                    })));
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
                }
            };

            fetchProjects();
        } else {
            setProjectResponse([]); // Reset projects if no client is selected
        }
    }, [clients]);


    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year, project]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setClients(null);
                setProject(null); // ✅ Clear project when state changes

                break;
            case 'district':
                setDistrict(value);
                // setProject(null); // ✅ Clear project when district changes
                break;
            case 'clients':
                setClients(value);
                setProject(null);
                // setProjectResponse([]);
                // setEmployees([]);
                // setEmployeeData([]);
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getMonthlyAttendanceReport({
                stateId: state,
                districtId: district,
                month,
                year,
                projectId: project,
            });

            const employeeData = data.employeeWiseReport || [];
            const designationWise = data.designationWiseReport || [];

            const initializedData = employeeData.map((item) => ({
                ...item,
                casualLeave: item.casualLeave || 0,
                absentDays: item.absentDays || 0,
            }));

            setAttendanceData(initializedData);
            setDesignationData(designationWise);
        } catch (error) {
            console.error("Error fetching report data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch report data",
            }));
            alert("Failed to fetch report data. Please try again.");
        }
    };




    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);


    const generateExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Monthly Attendance");

        // Title
        worksheet.mergeCells("A1:L1");
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Monthly Attendance Report";
        titleCell.font = { size: 16, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };
        titleCell.fill = {
            type: 'pattern',  // pattern type
            pattern: 'solid', // solid fill
            fgColor: { argb: 'FFFFA500' }, // orange color in hex (ARGB format)
        };
        // Letter Heading
        worksheet.getCell("A3").value = "To,";
        worksheet.getCell("B4").value = "The Managing Director";
        worksheet.getCell("B5").value = "BSFC, Khadya Bhawan";
        worksheet.getCell("B6").value = "Patna, Bihar.";



        // Report Date
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const yyyy = now.getFullYear();
        const reportDateTime = `${dd}-${mm}-${yyyy}`;
        // Report Heading
        worksheet.mergeCells("K3");
        worksheet.getCell("K3").value = "Report Date ";
        worksheet.getCell("K3").font = { bold: true };
        worksheet.getCell("K3").alignment = { horizontal: "right" };

        // District Value
        worksheet.mergeCells("L3");
        worksheet.getCell("L3").value = reportDateTime;
        //worksheet.getCell("L3").font = { bold: true };
        worksheet.getCell("L3").alignment = { horizontal: "center" };


        // Filters
        worksheet.addRow([]);
        const stateLabel = stateOptions.find((opt) => opt.value === state)?.label || "N/A";
        const districtLabel = districtOptions.find((opt) => opt.value === district)?.label || "N/A";
        const monthLabel = monthOptions.find((opt) => opt.value === month)?.label || "N/A";
        const projectLabel = projectResponse.find((opt) => opt.value === project)?.label || "N/A";
        // Project Heading
        worksheet.mergeCells("K6");
        worksheet.getCell("K6").value = "Project";
        worksheet.getCell("K6").font = { bold: true };
        worksheet.getCell("K6").alignment = { horizontal: "right" };

        // Project Value
        worksheet.mergeCells("L6");
        worksheet.getCell("L6").value = projectLabel;
        worksheet.getCell("L6").font = { bold: true };
        worksheet.getCell("L6").alignment = { horizontal: "center" };
        // District Heading
        worksheet.mergeCells("K7");
        worksheet.getCell("K7").value = "District";
        worksheet.getCell("K7").font = { bold: true };
        worksheet.getCell("K7").alignment = { horizontal: "right" };

        // District Value
        worksheet.mergeCells("L7");
        worksheet.getCell("L7").value = districtLabel;
        worksheet.getCell("L7").font = { bold: true };
        worksheet.getCell("L7").alignment = { horizontal: "center" };

        worksheet.mergeCells("A8:L8");
        worksheet.getCell("A8").value = {
            richText: [
                { text: "Attendance Record for the Month of " },
                { text: monthLabel, font: { bold: true } },
                { text: " and Year ", font: { bold: false } },
                { text: year || "N/A", font: { bold: true } },
            ],
        };

        worksheet.addRow([]);

        // Headers
        worksheet.addRow([
            "S.No",
            // "Employee Id",
            "Employee Name",
            "Contact Number",
            "Designation",
            "DHQ/ Godown Name",
            "No of Days in the Month",
            "No of Days Present",
            "Casual Leave (CL)",
            "No of Days Absent",
            "Total No of Days Present",
            "CL Used Status",
            "Total",
        ]);

        const headerRow = worksheet.lastRow;
        headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
        headerRow.alignment = { horizontal: "center" };
        headerRow.eachCell((cell) => {
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "4472C4" } };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // Column widths
        worksheet.columns = [
            { width: 5 },
            { width: 20 },
            { width: 20 },
            { width: 15 },
            { width: 25 },
            { width: 25 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 25 },
            { width: 25 },
            { width: 20 },
            { width: 25 },
        ];

        // Group by designation
        const groupedData = attendanceData.reduce((acc, item) => {
            (acc[item.designation] = acc[item.designation] || []).push(item);
            return acc;
        }, {});

        let serial = 1;
        let grandTotal = 0;

        for (const [designation, records] of Object.entries(groupedData)) {
            let groupTotal = 0;
            const startRowNum = worksheet.lastRow.number + 1;

            // Add rows with empty "Total" cells for now
            records.forEach((row) => {
                groupTotal += row.totalNoOfDaysPresent || 0;

                const dataRow = worksheet.addRow([
                    serial++,
                    row.employeeName || "",   // Employee Name
                    row.contactNo || row.contact || "",  // Contact
                    row.designation || "",
                    row.location || "",
                    row.totalDaysInMonth || row["No of Days in the Month"] || 0,
                    row.presentDays || row["No of Days Present"] || 0,
                    row.casualLeave || row["Casual Leave (CL)"] || 0,
                    row.absentDays || row["No of Days Absent"] || 0,
                    row.totalNoOfDaysPresent || row["Total No of Days Present"] || 0,
                    row.clUsedStatus || row["CL Used Status"] || "",
                    "",  // Leave Total column blank for now
                ]);

                dataRow.getCell(1).alignment = { horizontal: "center" };
                dataRow.getCell(11).alignment = { horizontal: "right" };
                dataRow.getCell(11).alignment = { horizontal: "right" };
            });

            const endRowNum = worksheet.lastRow.number;

            // Merge the "Total" column (13th column) cells vertically for this group
            worksheet.mergeCells(startRowNum, 12, endRowNum, 12);

            // Set the value of the first cell in the merged range to groupTotal
            worksheet.getCell(startRowNum, 12).value = groupTotal;
            worksheet.getCell(startRowNum, 12).alignment = { horizontal: "right" };
            // Add this group's total to grandTotal
            grandTotal += groupTotal;
        }

        // Blank row
        worksheet.addRow([]);

        // Grand Total row
        const totalRow = worksheet.addRow(["", "", "", "", "", "", "", "", "", "Total", "", grandTotal]);
        worksheet.mergeCells(`A${totalRow.number}:E${totalRow.number}`);
        totalRow.getCell(1).font = { bold: true };
        totalRow.getCell(10).font = { bold: true };
        totalRow.getCell(12).font = { bold: true };
        totalRow.getCell(10).alignment = { horizontal: "center" };

        // Signature section
        const sigRow = worksheet.lastRow.number + 2;
        worksheet.mergeCells(`A${sigRow}:B${sigRow}`);
        worksheet.getCell(`A${sigRow}`).value = "Cc.";
        worksheet.getCell(`A${sigRow}`).alignment = { horizontal: "right" };

        worksheet.mergeCells(`C${sigRow}:D${sigRow}`);
        worksheet.getCell(`C${sigRow}`).value = "1. To 4G Identity Solutions Pvt. Ltd.";

        worksheet.mergeCells(`F${sigRow + 1}:G${sigRow + 1}`);
        worksheet.getCell(`F${sigRow + 1}`).value = "IT Manager 4G Identity Solutions";
        worksheet.getCell(`F${sigRow + 1}`).alignment = { horizontal: "center" };

        worksheet.mergeCells(`J${sigRow + 1}:K${sigRow + 1}`);
        worksheet.getCell(`J${sigRow + 1}`).value = "District Manager, BSFC";
        worksheet.getCell(`J${sigRow + 1}`).alignment = { horizontal: "center" };

        worksheet.mergeCells(`F${sigRow + 2}:G${sigRow + 2}`);
        worksheet.getCell(`F${sigRow + 2}`).value = "Signature";
        worksheet.getCell(`F${sigRow + 2}`).alignment = { horizontal: "center" };

        worksheet.mergeCells(`J${sigRow + 2}:K${sigRow + 2}`);
        worksheet.getCell(`J${sigRow + 2}`).value = "Signature";
        worksheet.getCell(`J${sigRow + 2}`).alignment = { horizontal: "center" };

        // Download file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Monthly_Attendance_${month}_${year}.xlsx`;
        link.click();
    };




    // const generatePDF = () => {
    //     if (attendanceData.length === 0) {
    //         alert("No data to export");
    //         return;
    //     }

    //     // Use A4 Portrait
    //     const doc = new jsPDF({
    //         orientation: "portrait",
    //         unit: "mm",
    //         format: "a4",
    //     });
    //     const pageWidth = doc.internal.pageSize.getWidth();

    //     // Title centered
    //     doc.setFontSize(16);
    //     doc.setFont(undefined, "bold");
    //     doc.text("Monthly Attendance Report", pageWidth / 2, 15, { align: "center" });

    //     // --- Letter Heading (static) ---
    //     doc.setFontSize(11);
    //     doc.setFont(undefined, "normal");
    //     doc.text("To,", 14, 30);
    //     doc.text("The Managing Director", 25, 38);
    //     doc.text("BSFC, Khadya Bhawan", 25, 46);
    //     doc.text("Patna, Bihar.", 25, 54);

    //     // Filters & Report Date
    //     const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "N/A";
    //     const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "N/A";
    //     const monthLabel = monthOptions.find(opt => opt.value === month)?.label || "N/A";

    //     const now = new Date();
    //     const dd = String(now.getDate()).padStart(2, "0");
    //     const mm = String(now.getMonth() + 1).padStart(2, "0");
    //     const yyyy = now.getFullYear();
    //     const reportDateTime = `${dd}-${mm}-${yyyy}`;

    //     doc.setFontSize(11);
    //     doc.text(`Report Date: ${reportDateTime}`, pageWidth - 14, 30, { align: "right" });
    //     // District (label normal, value bold)
    //     const districtY = 70;

    //     // First, measure "District: " width
    //     doc.setFont(undefined, "normal");
    //     const label = "District: ";
    //     const labelWidth = doc.getTextWidth(label);

    //     // Position so text ends at the right margin
    //     let x = pageWidth - 14 - (labelWidth + doc.getTextWidth(String(districtLabel)));

    //     // Draw label (normal)
    //     doc.text(label, x, districtY);

    //     // Draw value (bold, right after label)
    //     doc.setFont(undefined, "bold");
    //     doc.text(String(districtLabel), x + labelWidth, districtY);

    //     // Reset font for later
    //     doc.setFont(undefined, "normal");


    //     // Attendance record title with mixed styles
    //     let startX = 14;
    //     const y = 70;
    //     doc.setFontSize(11);

    //     // Static text (normal)
    //     doc.setFont(undefined, "normal");
    //     doc.text("Attendance Record for the Month of ", startX, y);

    //     // Move X forward
    //     startX += doc.getTextWidth("Attendance Record for the Month of ");

    //     // Month (bold)
    //     doc.setFont(undefined, "bold");
    //     doc.text(String(monthLabel), startX, y);
    //     startX += doc.getTextWidth(String(monthLabel));

    //     // Static " and Year " (normal)
    //     doc.setFont(undefined, "normal");
    //     doc.text(" and Year  ", startX, y);
    //     startX += doc.getTextWidth(" and Year  ");

    //     // Year (bold)
    //     doc.setFont(undefined, "bold");
    //     doc.text(String(year || "N/A"), startX, y);

    //     // Reset font
    //     doc.setFont(undefined, "normal");


    //     // --- Table starts below header (shift down because of letter heading) ---
    //     const tableColumns = [
    //         "S.No",
    //         "Employee Name",
    //         "Contact No.",
    //         "Designation",
    //         "Location",
    //         "No of Days in the Month",
    //         "No of Days Present",
    //         "Casual Leave (CL)",
    //         "No of Days Absent",
    //         "Total No of Days Present",
    //         "CL Used Status",
    //         "Total",
    //     ];

    //     const groupedData = attendanceData.reduce((acc, item) => {
    //         (acc[item.designation] = acc[item.designation] || []).push(item);
    //         return acc;
    //     }, {});

    //     const tableRows = [];
    //     let serial = 1;
    //     let grandTotal = 0;
    //     const groupRowRanges = [];

    //     for (const [designation, records] of Object.entries(groupedData)) {
    //         const groupTotal = records.reduce((sum, r) => sum + (r.totalNoOfDaysPresent || 0), 0);
    //         grandTotal += groupTotal;

    //         const startRow = tableRows.length;

    //         records.forEach((row, idx) => {
    //             tableRows.push([
    //                 serial++,
    //                 row.employeeName || "",
    //                 row.contactNo || "",
    //                 row.designation || "",
    //                 row.location || "",
    //                 row.totalDaysInMonth || 0,
    //                 row.presentDays || 0,
    //                 row.casualLeave || 0,
    //                 row.absentDays || 0,
    //                 row.totalNoOfDaysPresent || 0,
    //                 row.clUsedStatus || "",
    //                 idx === records.length - 1 ? groupTotal : "",
    //             ]);
    //         });

    //         const endRow = tableRows.length - 1;
    //         groupRowRanges.push({ start: startRow, end: endRow, total: groupTotal });
    //     }

    //     doc.autoTable({
    //         startY: 75,
    //         head: [tableColumns],
    //         body: tableRows,
    //         theme: "grid",
    //         styles: { fontSize: 8, cellPadding: 2 },
    //         headStyles: { fillColor: [68, 114, 196], textColor: 255, fontStyle: "bold" },
    //         columnStyles: {
    //             0: { halign: "center" },
    //             12: { halign: "right" },
    //         },
    //         margin: { left: 14, right: 14 },
    //     });

    //     // (keep your merged "Total" column logic here if needed...)

    //     let finalY = doc.lastAutoTable.finalY + 10;
    //     doc.setFont(undefined, "bold");
    //     doc.text(`Total  ${grandTotal}`, pageWidth - 14, finalY, { align: "right" });

    //     finalY += 15;

    //     // Signature section
    //     doc.setFontSize(11);
    //     doc.setFont(undefined, "normal");
    //     doc.text("Cc.", 15, finalY);
    //     doc.text("1. To 4G Identity Solutions Pvt. Ltd.", 25, finalY);

    //     doc.text("IT Manager 4G Identity Solutions", 90, finalY + 25, { align: "center" });
    //     doc.text("District Manager, BSFC", pageWidth - 40, finalY + 25, { align: "center" });

    //     doc.text("Signature", 90, finalY + 30, { align: "center" });
    //     doc.text("Signature", pageWidth - 40, finalY + 30, { align: "center" });

    //     doc.save(`Monthly_Attendance_${month}_${year}.pdf`);
    // };

    const generatePDF = () => {
        if (attendanceData.length === 0) {
            alert("No data to export");
            return;
        }

        // Use A4 Portrait
        const doc = new jsPDF({
            orientation: "portrait", //landscape
            unit: "mm",
            format: "a4",
        });
        const pageWidth = doc.internal.pageSize.getWidth();

        // Title centered
        doc.setFontSize(16);
        doc.setFont(undefined, "bold");

        doc.text("Monthly Attendance Report", pageWidth / 2, 15, { align: "center" });

        // --- Letter Heading (static) ---
        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        doc.text("To,", 14, 30);
        doc.text("The Managing Director", 25, 38);
        doc.text("BSFC, Khadya Bhawan", 25, 46);
        doc.text("Patna, Bihar.", 25, 54);


        // Filters & Report Date
        const stateLabel = stateOptions.find(opt => opt.value === state)?.label || "N/A";
        const districtLabel = districtOptions.find(opt => opt.value === district)?.label || "N/A";
        const monthLabel = monthOptions.find(opt => opt.value === month)?.label || "N/A";
        const projectLabel = projectResponse.find((opt) => opt.value === project)?.label || "N/A";

        const now = new Date();
        const dd = String(now.getDate()).padStart(2, "0");
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const yyyy = now.getFullYear();
        const reportDateTime = `${dd}-${mm}-${yyyy}`;

        doc.setFontSize(11);
        doc.text(`Report Date: ${reportDateTime}`, pageWidth - 14, 30, { align: "right" });


        // Project (label normal, value bold) → Right side
        const projectY = 65;
        const projectLabelText = "Project: ";
        const projectValueText = String(projectLabel);

        // total width of label + value
        const projectTextWidth =
            doc.getTextWidth(projectLabelText) + doc.getTextWidth(projectValueText);

        // starting x so that full text ends 14mm before right edge
        let projectX = pageWidth - 14 - projectTextWidth;

        // draw label (normal)
        doc.setFont(undefined, "normal");
        doc.text(projectLabelText, projectX, projectY);

        // draw value (bold)
        doc.setFont(undefined, "bold");
        doc.text(projectValueText, projectX + doc.getTextWidth(projectLabelText), projectY);


        // District (label normal, value bold)
        const districtY = 70;
        const label = "District: ";
        doc.setFont(undefined, "normal");
        const labelWidth = doc.getTextWidth(label);
        let x = pageWidth - 14 - (labelWidth + doc.getTextWidth(String(districtLabel)));
        doc.text(label, x, districtY);
        doc.setFont(undefined, "bold");
        doc.text(String(districtLabel), x + labelWidth, districtY);
        doc.setFont(undefined, "normal");

        // Attendance record title with mixed styles
        let startX = 14;
        const y = 70;
        doc.setFontSize(11);

        doc.setFont(undefined, "normal");
        doc.text("Attendance Record for the Month of ", startX, y);
        startX += doc.getTextWidth("Attendance Record for the Month of ");

        doc.setFont(undefined, "bold");
        doc.text(String(monthLabel), startX, y);
        startX += doc.getTextWidth(String(monthLabel));

        doc.setFont(undefined, "normal");
        doc.text(" and Year ", startX, y);
        startX += doc.getTextWidth(" and Year ");

        doc.setFont(undefined, "bold");
        doc.text(String(year || "N/A"), startX, y);
        doc.setFont(undefined, "normal");

        // --- Table starts below header ---
        const tableColumns = [
            "S.No",
            "Employee Name",
            "Contact Number",
            "Designation",
            "DHQ/ Godown Name",
            "No of Days in the Month",
            "No of Days Present",
            "Casual Leave (CL)",
            "No of Days Absent",
            "Total No of Days Present",
            "CL Used Status",
            "Total",
        ];

        const groupedData = attendanceData.reduce((acc, item) => {
            (acc[item.designation] = acc[item.designation] || []).push(item);
            return acc;
        }, {});

        const tableRows = [];
        let serial = 1;
        let grandTotal = 0;
        const groupRowRanges = [];

        for (const [designation, records] of Object.entries(groupedData)) {
            const groupTotal = records.reduce((sum, r) => sum + (r.totalNoOfDaysPresent || 0), 0);
            grandTotal += groupTotal;

            const startRow = tableRows.length;

            records.forEach((row, idx) => {
                tableRows.push([
                    serial++,
                    row.employeeName || "",
                    row.contactNo || "",
                    row.designation || "",
                    row.location || "",
                    row.totalDaysInMonth || 0,
                    row.presentDays || 0,
                    row.casualLeave || 0,
                    row.absentDays || 0,
                    row.totalNoOfDaysPresent || 0,
                    row.clUsedStatus || "",
                    idx === records.length - 1 ? groupTotal : "", // Only last row shows total
                ]);
            });

            const endRow = tableRows.length - 1;
            groupRowRanges.push({ start: startRow, end: endRow, total: groupTotal });
        }

        doc.autoTable({
            startY: 75,
            head: [tableColumns],
            body: tableRows,
            theme: "grid",
            styles: { fontSize: 8, cellPadding: 2 },
            headStyles: { fillColor: [68, 114, 196], textColor: 255, fontStyle: "bold" },
            columnStyles: {
                0: { halign: "center" },
                12: { halign: "right" },
            },
            margin: { left: 14, right: 14 },
        });

        // --- Merge "Total" column per designation ---
        const table = doc.lastAutoTable;
        const colIndex = 12; // "Total" column index

        groupRowRanges.forEach(({ start, end, total }) => {
            if (end >= start) {
                const firstRow = table.body[start];
                const lastRow = table.body[end];

                if (!firstRow || !lastRow) return;

                const yStart = firstRow.y;
                const yEnd = lastRow.y + lastRow.height;

                const col = table.columns[colIndex];
                if (!col) return;

                const x = col.startX;
                const width = col.width;
                const height = yEnd - yStart;

                doc.setDrawColor(0);
                doc.setFillColor(230);
                doc.rect(x, yStart, width, height, "F");

                doc.setFont(undefined, "bold");
                doc.setFontSize(8);
                doc.setTextColor(0);

                const textX = x + width / 2;
                const textY = yStart + height / 2;

                doc.text(String(total), textX, textY, { align: "center", baseline: "middle" });
            }
        });


        // --- Grand total row ---
        // --- Grand total row ---
        let finalY = doc.lastAutoTable.finalY;
        doc.autoTable({
            body: [
                [" ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", "Total", " ", grandTotal]
            ],
            theme: "grid",
            styles: { fontSize: 9, halign: "center", textColor: [0, 0, 0] },
            columnStyles: {
                9: { fontStyle: "bold", halign: "right", textColor: [0, 0, 0] },  // "Total" under col 9 header
                11: { fontStyle: "bold", halign: "center", textColor: [0, 0, 0] } // Grand total value under col 11
            },
            startY: finalY,
            margin: { left: 14, right: 14 },
        });


        finalY = doc.lastAutoTable.finalY + 15;

        // Signature section
        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        doc.text("Cc.", 15, finalY);
        doc.text("1. To 4G Identity Solutions Pvt. Ltd.", 25, finalY);

        doc.text("IT Manager 4G Identity Solutions", 90, finalY + 10, { align: "center" });
        doc.text("District Manager, BSFC", pageWidth - 40, finalY + 10, { align: "center" });

        doc.text("Signature", 90, finalY + 15, { align: "center" });
        doc.text("Signature", pageWidth - 40, finalY + 15, { align: "center" });

        doc.save(`Monthly_Attendance_${month}_${year}.pdf`);
    };



    const groupedEmployees = attendanceData.reduce((acc, employee) => {
        const { designation } = employee;
        if (!acc[designation]) {
            acc[designation] = [];
        }
        acc[designation].push(employee);
        return acc;
    }, {});

    const designationTotals = designationData.reduce((acc, item) => {
        acc[item.designation.trim().toLowerCase()] = item.totalPresentDays;
        return acc;
    }, {});


    return (
        <div className="monthly-report-container">
            <div className="monthly-report-box">
                <h2 className="monthly-report-heading">Monthly Attendance Report</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="monthly-report-maincontainer">
                        <div className="monthly-report-container-part">
                            <div className={`monthly-report-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="monthly-report-container-part">
                            <div className={`monthly-report-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>Working District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="monthly-report-maincontainer">
                        <div className="monthly-report-container-part">
                            <div className={`monthly-report-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="monthly-report-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="monthly-report-container-part">
                            <div className={`monthly-report-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="monthly-report-maincontainer">
                        <div className="monthly-report-container-part">
                            <div className={`monthly-report-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                                <Select
                                    name="clients"
                                    options={clientResponse}
                                    value={clientResponse.find(opt => opt.value === clients) || null}
                                    onChange={option => handleInputChange(option, 'clients')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Client</label>
                                {errors.clients && <div className="error-message">{errors.clients}</div>}
                            </div>

                        </div>

                        <div className="monthly-report-container-part">
                            <div className={`monthly-report-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>
                                    <span className="required">*</span>Project
                                </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>

                    </div>
                    <div className="monthly-report-btn-div">
                        <button type="submit" className="monthly-report-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Generate Report
                        </button>
                    </div>
                </form>
            </div>


            <div className="report-table-monthlt-att-container">
                <div className="monthly-report-btn-div">
                    <button
                        type="button"
                        className="monthly-report-btn"
                        onClick={generateExcel}
                        disabled={attendanceData.length === 0}  // ✅ disabled if no data
                    >
                        Download Excel
                    </button>
                    <button
                        type="button"
                        className="monthly-report-btn"
                        onClick={generatePDF}
                        disabled={attendanceData.length === 0}  // ✅ disabled if no data
                    >
                        Download PDF
                    </button>
                </div>


                <table className="report-table-monthlt-att">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Employee Id</th>
                            <th>Employee Name</th>
                            <th>Contact Number</th>
                            <th>Designation</th>
                            <th>DHQ/ Godown Name</th>
                            <th>No of Days in the Month</th>
                            <th>No.of Days Present</th>
                            <th>Casual Leave (CL)</th>
                            <th>No of Days Absent</th>
                            <th>Total No of Days Present</th>
                            <th>CL Used Status</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attendanceData.length > 0 ? (
                            (() => {
                                let serial = 1;
                                return Object.entries(groupedEmployees).map(([designation, employees]) => {
                                    const designationTotal = employees.reduce(
                                        (acc, emp) => acc + (emp.totalNoOfDaysPresent || 0),
                                        0
                                    );

                                    return (
                                        <React.Fragment key={designation}>
                                            {employees.map((row, index) => (
                                                <tr key={row.employeeId}>
                                                    <td>{serial++}</td>
                                                    <td>{row.employeeId}</td>
                                                    <td>{row.employeeName}</td>
                                                    <td>{row.contactNo}</td>
                                                    <td>{row.designation}</td>
                                                    <td>{row.location}</td>
                                                    <td>{row.totalDaysInMonth}</td>
                                                    <td>{row.presentDays}</td>
                                                    <td>{row.casualLeave}</td>
                                                    <td>{row.absentDays}</td>
                                                    <td>{row.totalNoOfDaysPresent}</td>
                                                    <td>{row.clUsedStatus}</td>
                                                    {index === 0 ? (
                                                        <td
                                                            rowSpan={employees.length}
                                                            style={{ fontWeight: "bold", textAlign: "right", verticalAlign: "middle" }}
                                                        >
                                                            {designationTotal}
                                                        </td>
                                                    ) : null}
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    );
                                });
                            })()
                        ) : (
                            <tr>
                                <td colSpan="13" style={{ textAlign: "center", padding: "20px" }}>
                                    No attendance data available
                                </td>
                            </tr>
                        )}

                        {attendanceData.length > 0 && (
                            <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>
                                <td colSpan="11" style={{ textAlign: "right" }}>
                                    Total
                                </td>
                                <td></td>
                                <td style={{ textAlign: "right" }}>
                                    {Object.values(groupedEmployees)
                                        .flat()
                                        .reduce((sum, emp) => sum + (emp.totalNoOfDaysPresent || 0), 0)}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


        </div>
    );
};

export default MonthlyAttendanceReport;